// Maison Odile · botón «Add» de las sugerencias del carrito (Horizon). Lo sube shopify/retencion.py.
// Añade por /cart/add.js y avisa al tema con el mismo evento que su formulario de producto,
// para que el cajón y la página del carrito se vuelvan a pintar.
let Ev = null;
try { ({ CartLinesUpdateEvent: Ev } = await import('@shopify/events')); } catch (e) { Ev = null; }

document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-mo-add]');
  if (!b || b.disabled) return;
  e.preventDefault();
  b.disabled = true;
  b.setAttribute('aria-busy', 'true');
  const id = Number(b.dataset.moAdd);
  const secciones = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const diferido = Ev ? Ev.createPromise() : null;
  if (Ev) b.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: diferido.promise }));
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: secciones.join(','), sections_url: location.pathname }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'add failed');
    if (!Ev) { location.reload(); return; }
    const cart = await (await fetch('/cart.js')).json();
    diferido.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mo-cart-extras', itemCount: 1, sections: j.sections, didError: false } });
  } catch (err) {
    console.error('mo-cart-extras', err);
    if (diferido) diferido.reject(err);
    b.disabled = false;
    b.removeAttribute('aria-busy');
  }
});
